<template>
  <HelloWorld/>
</template>

<script>
import HelloWorld from './components/HelloWorld.vue'

export default {
  name: 'App',
  components: {
    HelloWorld
  }
}
</script>

<style>
html, body {
  overflow: hidden;
  min-height: 100%;
}
body {
  height: 100vh;
  width: 100vw;
}
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 0px;
  background-color: #000000;
  color: #ffffff;
  height: 100vh;
}


@font-face {
  font-family: "Egoistism";
  src: local("Egoistism"),   url(./font/D3Egoistism1.TTF) format("truetype");
}

</style>
